import PageLayout from "../components/common/page-layout";
import IngestionInspector from "../components/ingestion-inspector";
import { RequireAuth } from "../hooks/use-auth";

/**
 * The ingestion prefill inspector: inspect the zero-LLM billing-party prefill
 * verdicts and bill-to candidate set the V3 document-apply path computes for a
 * company. Sits alongside the Doc Extraction Evals tool.
 */
const IngestionInspectorPage = () => {
  return (
    <RequireAuth>
      <PageLayout
        subtitle="New document-extraction pipeline"
        title="Ingestion prefill inspector"
      >
        <IngestionInspector />
      </PageLayout>
    </RequireAuth>
  );
};

export default IngestionInspectorPage;
